import moment from 'moment'
import { getFormattedValidationErrorFromAction } from 'Shared/Util'

const typeVirtualVoucher = 'EXTERNALVOUCHERVIRTUAL'
const equalsVirtualVoucher = item => item.vendor.type === typeVirtualVoucher
const diffVirtualVoucher = item => item.vendor.type !== typeVirtualVoucher

const calculatorCount = (current, item) => {
  return current + item.quantity
}

export default (
  state = {
    isLoading: false,
    wasModified: false,
    isUpdating: false,
    items: [],
    shipping: { isLoading: false, error_get_shipping: true },
    isUpdatingShippingAddressToCart: false,
    coupon: { isLoading: false }
  },
  action
) => {
  if (state.prop) {
    delete state.prop
  }
  switch (action.type) {
    case 'FETCH_CART':
      return { ...state, isLoading: true }
    case 'FETCH_CART_SUCCESS':
      const { data } = action.payload
      const count = data.items.reduce(calculatorCount, 0)

      const hasItemsVirtualVoucher = data.items.some(equalsVirtualVoucher)
      const hasItemsDifferentVirtualVoucher = data.items.some(
        diffVirtualVoucher
      )

      return {
        ...state,
        ...data,
        isLoading: false,
        count,
        hasItemsVirtualVoucher,
        hasItemsDifferentVirtualVoucher,
        itemAdded: false,
        isError: false
      }
    case 'CLEAR_ERROR_CART':
      return {
        ...state,
        isLoading: false,
        error: null,
        hasError: false,
        errorData: []
      }
    case 'FETCH_CART_FAIL':
      const reponseFetchCartFail = action.error.data.response
      return {
        ...state,
        isLoading: false,
        error: action.error.data,
        itemAdded: false,
        isError: false,
        hasError: true,
        errorData: reponseFetchCartFail && reponseFetchCartFail.data ? reponseFetchCartFail.data : [],
        statusCode: action.status
      }
    case 'FETCH_CART_REDIRECT':
      return { ...state }
    case 'ADD_ITEM_TO_CART':
      return { ...state, isLoading: true }

    case 'ADD_ITEM_TO_CART_SUCCESS':
      return {
        ...state,
        itemAdded: true
      }
    case 'ADD_ITEM_TO_CART_FAIL':
      const errorData = getFormattedValidationErrorFromAction(action)
      return {
        ...state,
        isLoading: false,
        isLoadingRedirect: false,
        errorData,
        isError: true
      }
    case 'ADD_ITEM_TO_CART_REDIRECT':
      return { ...state, isLoadingRedirect: true }
    case 'ADD_ITEM_TO_CART_REDIRECT_SUCCESS':
      return {
        ...state,
        isLoadingRedirect: false
      }
    case 'UPDATE_ITEM_FROM_CART':
      return { ...state, isLoading: true, wasModified: true, isUpdating: true }
    case 'UPDATE_ITEM_FROM_CART_SUCCESS':
      return { ...state, isLoading: false, isUpdating: false }
    case 'UPDATE_ITEM_FROM_CART_FAIL':
      const error = getFormattedValidationErrorFromAction(action)
      return {
        ...state,
        isLoading: false,
        isUpdating: false,
        error: action.error.data,
        shipping: {
          isLoading: false,
          error: action.error.data,
          fetchShipping: false,
          error_get_shipping: true
        },
        hasError: true,
        errorData: error,
        statusCode: action.status
      }
    case 'FETCH_CART_SHIPPING':
      return { ...state, shipping: { isLoading: true, fetchShipping: false } }
    case 'FETCH_CART_SHIPPING_SUCCESS':
      const deliveriesDate = action.payload.data.vendors.map(
        ({ deliveryDate }) => moment(deliveryDate)
      )
      const maxDeliveryDate = moment.max(deliveriesDate).format('DD/MM/YYYY')

      return {
        ...state,
        shipping: {
          isLoading: false,
          ...action.payload.data,
          maxDeliveryDate,
          fetchShipping: true
        }
      }
    case 'FETCH_CART_SHIPPING_FAIL':
      const {
        response: {
          data: { errors = null, messages = null } = null,
          status
        }
      } = action.error
      const getFirstOnly = (array, param) => ((array && array.length > 0 && array[0][param]) || '')
      const messageError = getFirstOnly(errors, 'message') || getFirstOnly(messages, 'description') || 'Não foi possível concluir, entre em contato com o suporte.'
      const subMessageError = getFirstOnly(errors, 'subMessage')

      return {
        ...state,
        shipping: {
          isLoading: false,
          error: messageError,
          errorSub: subMessageError,
          fetchShipping: false,
          error_get_shipping: true
        },
        hasError: true,
        errorData: errors || [],
        statusCode: status
      }
    case 'RESET_CART_SHIPPING':
      return {
        ...state,
        shipping: { isLoading: false, fetchShipping: false }
      }
    case 'UPDATE_SHIPPING_ADDRESS_TO_CART':
      return { ...state, updateShippingAddress: 'loading' }
    case 'UPDATE_SHIPPING_ADDRESS_TO_CART_SUCCESS':
      return {
        ...state,
        updateShippingAddress: 'success'
      }
    case 'UPDATE_SHIPPING_ADDRESS_TO_CART_FAIL':
      const shippingError = getFormattedValidationErrorFromAction(action)
      return {
        ...state,
        updateShippingAddress: 'failed',
        shipping: { fetchShipping: false },
        messageError: shippingError.message,
        subMessageError: shippingError.subMessage,
        statusCode: shippingError.statusCode,
        hasError: true
      }
    case 'CHANGE_EMAIL':
      return {
        ...state
      }
    case 'CHANGE_EMAIL_SUCCESS':
      return {
        ...state,
        customer: { ...state.customer, email: action.meta.previousAction.email }
      }
    case 'CART_UPDATE_COUPON':
      return {
        ...state,
        coupon: { isLoading: true }
      }
    case 'CART_UPDATE_COUPON_SUCCESS':
      return {
        ...state,
        coupon: { isLoading: false, hasError: false, ...action.payload.data }
      }
    case 'CART_UPDATE_COUPON_FAIL':
      return {
        ...state,
        coupon: { isLoading: false, hasError: true }
      }
    case 'CART_REMOVE_COUPON':
      return {
        ...state,
        coupon: { ...state.coupon, isLoading: true }
      }
    case 'CART_REMOVE_COUPON_SUCCESS':
      return {
        ...state,
        coupon: { isLoading: false }
      }
    case 'CART_REMOVE_COUPON_FAIL':
      return {
        ...state,
        coupon: {
          ...state.coupon,
          isLoading: false
        }
      }
    case 'CART_COUPON_CLEAR_ERROR':
      return {
        ...state,
        coupon: { ...state.coupon, hasError: false }
      }
    case 'CREATE_PURCHASE_FAIL':
      return {
        ...state,
        shipping: {
          ...state.shipping,
          error: null
        }
      }
    default:
      return { ...state }
  }
}



// WEBPACK FOOTER //
// ./src/features/Cart/reducer.js